//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = am || {};


/**
 * @namespace am.utils
 * Namespace containing utility functions
 */
am.utils = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * Function converting a color string into its corresponding RGB triplet
     * 
     * @param {String} color - String defining the color (ex: 'red', 'blue', etc.)
     * @return {Number[]} - RGB triplet corresponding to the color string
     */
    module.color2rgb = function(color) {
        if(Array.isArray(color) && (color.length == 3 || color.length == 4)) {
            for (var iColor = 0, nColors = color.length; iColor < nColors; ++iColor) {
                color[iColor] = parseInt(color[iColor]);
            }
            return color;
        } else if (typeof color === "string" && color[0] === '#') {
            if (color.length !== 7) {
                throw new Error("Color in hexadecimal notation must contain 7 characters (including the leading #)");
            }
            return [parseInt(color.substring(1, 3), 16), parseInt(color.substring(3, 5), 16), parseInt(color.substring(5), 16)];
        } else {
            switch(color) {
            case 'red':     return [255, 0, 0];
            case 'blue':    return [0, 0, 255];
            case 'green':   return [0, 255, 0];    
            case 'yellow':  return [255, 255, 0];  
            case 'cyan':    return [0, 255, 255];  
            case 'magenta': return [255, 0, 255];  
            case 'white':   return [255, 255, 255];
            case 'black':   return [0, 0, 0];      
            case 'orange':  return [255, 125, 0];
            default:        throw new Error("Unknown color '" + color + "'");
            }
        }
    };


    /**
     * Function overriding the properties of the first input object with those of the
     * second input object. This function is useful to override the default options
     * of a function with the options specified by the user. It is strongly advised to
     * use only custom objects as input arguments, since not only the own properties 
     * of the objects will be copied, but also those of their respective prototypes.
     * The two input objects will not be modified.
     * 
     * @param {Object} overridenObject - First input object
     * @param {Object} overridingObject - Second input object
     * @return {Object} - Object having all the properties of the first input object and
     *      all those of the second input object. In case a property is common to both
     *      input objects, the returned object will contain the value stored in the second
     *      input object.
     */
    module.mergeObjects = function(overridenObject, overridingObject, recursionLevel) {
        var output = {};
        recursionLevel = recursionLevel === undefined ? 999 : recursionLevel;
        if (recursionLevel > 0) {
            for (var property in overridenObject) {
                output[property] = overridenObject[property];
            }
        }
        for (var property in overridingObject) {
            // If output[property] already exists and is a "regular" javascript object
            // (e.g. NOT a basic type like Number, String or Array, but {"coucou" : "test"}),
            // then do a reccursive call
            if (output.hasOwnProperty(property) &&
                typeof output[property] == 'object' && 
                !Array.isArray(output[property]) && 
                Object.keys(output[property]).length > 0 &&
                recursionLevel > 0) {
                output[property] = module.mergeObjects(output[property], overridingObject[property], recursionLevel - 1);
            } else {
                output[property] = overridingObject[property];
            }
        }
        return output;
    };


    /**
     * Function returning a shallow copy of the object passed as input argument.
     * Note: only the own properties of the object will be copied.
     *
     * @param {Object} object - Object to be copied
     * @return {Object} - Shallow copy of the object passed as input argument
     */
    module.shallowCopy = function(object) {
        return module.mergeObjects({}, object);
    };
    

    /**
     * Flattens the array passed as input argument. This function supports nested arrays.
     *
     * @param {Array} arr - Array to flatten
     * @param {Array} - Flattened array
     */
    module.flattenArray = function(arr) {
        return arr.reduce(function(flattenedArray, nextElement) {
            return flattenedArray.concat(Array.isArray(nextElement) ? module.flattenArray(nextElement) : nextElement);
        }, []);
    };


    /**
     * Returns an array with the given size and filled with the given initial value
     * @param {Number} size - Length of the returned array
     * @param {*} initialValue - Initial value of each element in the returned array
     * @returns {Array} - Array filled with the given initial value
     */
    module.createArray = function(size, initialValue) {
        var arr = [];
        arr.length = size;

        if (initialValue !== undefined) {
            for (var i = 0; i < size; ++i) {
                arr[i] = initialValue;
            }
        }

        return arr;
    };


    /**
     * Used to execute the callback function passed as argument when the document is ready.
     *
     * @param {Function} callback - Callback function to be executed when all the HTML elements of the current page have
     *      been instantiated.
     */
    module.onDocumentReady = (function() {
        // Static private variable storing all the callbacks
        var callbacks = [];

        // Call the callbacks when the document is ready
        window.onload = function() {
            callbacks.forEach(function(callback) {
                callback();
            });
        };

        // Return the function which can be used to add functions to the list of callbacks
        return function(callback) {
            if (document.readyState == "complete") {
                callback();
            } else {
                callbacks.push(callback);
            }
        };
    })();


    /**
     * Used to prevent the propagation of events beyond the DOM element passed as input argument. This function is
     * particularly useful to avoid e.g. panning the map when interacting with a widget.
     *
     * @param {DomElement} domElement - The events targeted at this DOM element will not be propagated beyond the element
     *      (event bubbling will be prevented beyond this element)
     */
    module.preventMapInteractionOverElement = function(domElement) {
        var stop = L.DomEvent.stopPropagation;
        L.DomEvent.on(domElement, 'contextmenu mousedown touchstart mousewheel MozMousePixelScroll', 
            stop);
        L.DomEvent.on(domElement, 'dblclick', L.DomEvent._fakeStop || stop);
    };


    /**
     * Used to restore the propagation of events beyond the DOM element passed as input argument. This function is
     * the exact opposite of am.utils.blockEventPropagation.
     *
     * @param {DomElement} domElement - The events targeted at this DOM element will no longer be stopped beyond the
     *      element (event bubbling will be restored on this element)
     */
    module.restoreMapInteractionOverElement = function(domElement) {
        var stop = L.DomEvent.stopPropagation;
        L.DomEvent.off(domElement, 'contextmenu mousedown touchstart mousewheel MozMousePixelScroll', 
            stop);
        L.DomEvent.off(domElement, 'dblclick', L.DomEvent._fakeStop || stop);
    };


    /**
     * Returns a new instance of a Promise object whose "resolve" and "reject" methods are exposed (i.e. public) and can 
     * be called by third-party objects. The Promise in itself does not perform any action.
     *
     * @return {Promise} - New controllable Promise
     */
    module.controllablePromise = function() {
        var res, rej;

        var promise = new Promise(function(resolve, reject) {
            res = resolve;
            rej = reject;
        });

        promise.resolve = res;
        promise.reject = rej;

        return promise;
    };


    /**
     * Returns a function which can be used to color the features of a L.VectorGrid object by category, based on the 
     * values of a property (see example at https://leaflet.github.io/Leaflet.VectorGrid/vectorgrid-api-docs.html#styling-vectorgrids).
     *
     * @param {String} field - Name of the layer field based on which the feature categories should be defined
     * @param {Number[]} bounds - Array containing the values separating the different categories. 
     *      The first category will be assumed to contain all the features whose field value is contained between 
     *      -Infinity and the first element in array "bounds"; the second catagory will contain all the features whose 
     *      field value is contained between the first and second elements of input argument "bounds", etc.
     * @param {(am.ColorScale|Array)} colors - Object defining the color to be given to each category of features. 
     *      Two possibilities are available for this object:
     *        - An instance of class am.ColorScale, which will be used to color the feature categories according 
     *          to a color scale.
     *        - An array of strings or RGB triplets defining the individual color of each category. This array should 
     *          have one element more than argument "bounds".
     *      This argument defaults to a color scale ranging from red to green, passing through yellow.
     * @param {L.Path} drawStyle - Object defining the style to be given to all the categories of features. See 
     *      http://leafletjs.com/reference-1.2.0.html#path for a list of all available options. Note that, except for
     *      the color, all the feature categories will be displayed using the same style.
     * @return {Function} - Style to be used to color a layer by category
     */
    module.colorFeaturesByCategory = function(field, bounds, colors, drawStyle) {
        // Add -Infinity and +Infinity in the "bounds" array
        bounds = bounds.slice(); // make copy of input array
        bounds.unshift(-Infinity);
        bounds.push(Infinity);
        var nCategories = bounds.length - 1;

        // Define the color of each category, if not already specified by the user
        colors = colors || new am.ColorScale(['red', 'yellow', 'green']);
        if (colors instanceof am.ColorScale) {
            var newColors = [];
            for (var iCategory = 0; iCategory < nCategories; ++iCategory) {
                newColors.push(colors.getColor(iCategory/(nCategories - 1.)));
            }
            colors = newColors;
        } else { // colors instanceof Array
            colors = colors.slice(); // copy array (to avoid external modifications to affect the present function)
        }

        // Define the style of each category (the stroke and fill colors will be given by array "colors")
        var defaultStyle = {
            stroke: true,
            weight: 2,         // stroke width
            opacity: 1,        // stroke alpha
            lineJoin: 'round',
            dashArray: null,
            dashOffset: null,
            fill: true,
            fillOpacity: 0.5,  // fill alpha
        };
        var style = am.utils.mergeObjects(defaultStyle, drawStyle);
    
        // Create the returned function
        return function (featureProperties, zoomLevel) {
            var fieldValue = featureProperties[field];
            for (var iCategory = 0; iCategory < nCategories; ++iCategory) {
                if (fieldValue >= bounds[iCategory] && fieldValue < bounds[iCategory + 1]) {
                    var color = colors[iCategory];
                    var color = (typeof color == 'string') ? color : 'rgb(' + color.join() + ')';
                    var featureStyle = am.utils.shallowCopy(style);
                    featureStyle.color = style.color || color
                    featureStyle.fillColor = style.fillColor || color;
                    return featureStyle;
                }
            }
        };
    };

    /**
     * Tests whether the URL contains parameters (i.e. if the URL ends with a string of the type '?key=value')
     *
     * @param {String} parameter - Name of the parameter whose presence in the URL is to be tested
     */
    module.isParameterInUrl = function (parameter) {
        var questionMarkPos = window.location.href.indexOf('?');
        return questionMarkPos != -1 && questionMarkPos < window.location.href.indexOf(parameter);
    };

    /**
     * Returns the parameters contained in the URL
     *
     * @param {String} [url] - Optional string specifying the URL to parse. If not indicated, the current page URL is
     *      parsed.
     * @return {Object} - Object holding the parameters contained in the URL (after the '?' character)
     */
    module.getUrlParameters = function (url) {
        url = url || window.location.search;
        var paramString = url.substr(url.indexOf('?') + 1); // strip off everything before (and including) the '?' character
        var params = {};
        paramString.split('&').forEach(function(keyValuePair) {
            if (keyValuePair.length > 0) {
                var parts = keyValuePair.split('=');
                var key   = parts[0];
                var value = parts[1];
                if (!isNaN(value)) {
                    value = parseFloat(value);
                } else if (value.indexOf('|') !== -1 || value.indexOf('%7C') !== -1) {
                    var elements = (value.indexOf('|') !== -1) ? value.split('|') : value.split('%7C');
                    value = [];
                    elements.forEach(function(element) {
                        if (element.length > 0) {
                            value.push(isNaN(element) ? element : parseFloat(element));
                        }
                    });
                } else if (value == "true") {
                    value = true;
                } else if (value == "false") {
                    value = false;
                }
                params[key] = value;
            }
        });
        return params;
    };


    /**
     * Combines the input parameters into a string that can be appended to the current URL and describes the current
     * application state
     *
     * @param {Object} parameters - Object holding the names and values of the parameters to be stored in the URL
     * @returns {String} String containing all the input parameters, separated with '&' characters
     */
    module.combineUrlParameters = function (parameters) {
        var params = [];

        if (Object.keys(parameters).length > 0) {
            for (var key in parameters) {
                var value = parameters[key];
                if (value instanceof Array) {
                    value = '|' + value.join('|') + '|';
                }
                params.push(key + '=' + value);
            }
        }

        return params.join('&');
    };

    /**
     * Replaces the parameters in the URL (i.e. the contents of the URL after the '?' character)
     *
     * @param {Object} parameters - Object holding the names and values of the parameters to be stored in the URL
     */
    module.setUrlParameters = function (parameters) {
        if (Object.keys(parameters).length > 0) {
            var newUrl = window.location.pathname + '?' + module.combineUrlParameters(parameters);
            if (window.history.state == undefined || window.history.state.url !== newUrl) {
                window.history.pushState({ url: newUrl }, "", newUrl);
            }
        }
    };

    /**
     * Adds (or updates) the given parameter in the URL
     *
     * @param {String} name - Name of the parameter to be added in the URL
     * @param {String} value - Value of the parameter to be added in the URL
     */
    module.addUrlParameter = function (name, value) {
        var params = am.utils.getUrlParameters();
        params[name] = value;
        am.utils.setUrlParameters(params);
    };

    /**
     * Adds (or updates) the given parameters in the URL
     *
     * @param {Object} parameters - Object holding the names and values of the parameters to be added in the URL
     */
    module.addUrlParameters = function (parameters) {
        var currParams = am.utils.getUrlParameters();
        var newParams  = am.utils.mergeObjects(currParams, parameters);
        am.utils.setUrlParameters(newParams);
    };

    /**
     * Removes the given parameter from the URL
     *
     * @param {String} parameter - Name of the parameter to be removed from the URL
     */
    module.removeUrlParameter = function (parameter) {
        var params = am.utils.getUrlParameters();
        delete params[parameter];
        am.utils.setUrlParameters(params);
    };

    /**
     * Removes the given parameters from the URL
     *
     * @param {String} parameters - Names of the parameters to be removed from the URL
     */
    module.removeUrlParameters = function (parameters) {
        var params = am.utils.getUrlParameters();
        for (var iParam = 0, nParams = parameters.length; iParam < nParams; ++iParam) {
            delete params[parameters[iParam]];
        }
        am.utils.setUrlParameters(params);
    };

    /**
     * Generate a unique id (#2747)
     * @returns {string} - uid of 32 characters
     */
    module.generateUid = function () {
        return 'xxxxxxxx-xxxx-6xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    };

    /**
     * Rounds the given number up to the multiple passed as second input argument
     * @param number Number to be rounded
     * @param multiple Multiple up to which the first input should be rounded (defaults to 1)
     */
    module.round = function(number, multiple) {
        return (multiple !== 0) ? Math.round(number / multiple) * multiple : number;
    };

    /**
     * Function returning an instance of L.TileLayer corresponding to the Bing aerial maps
     *
     * @param {string} apiKey - Bing Maps API key
     * @return {L.TileLayer} - Bing aerial maps 
     */
    module.bingAerialLayer = function (apiKey) {
        var options = {
            maxNativeZoom: 18,
            maxZoom: 20,
            bingMapsKey: apiKey,
            className: 'am-base-layer',
            crossOrigin: true
        };
        var baseLayer = L.tileLayer.bing(options);
        baseLayer.icon = '/img/pictures/map-bing-aerial.png';
        baseLayer.class = 'map-bing-aerial';
        baseLayer.id = 'map-bing-aerial';
        return baseLayer;
    };

    /**
     * Function returning an instance of L.TileLayer corresponding to the aerial maps of IGN
     * (see https://geoservices.ign.fr/documentation/utilisation_web/wmts-ol3.html)
     *
     * @param {String} apiKey - IGN API key
     * @param {String|Number} year - Year in which the data was collected
     * @return {L.TileLayer} - IGN aerial maps
     */
    module.ignAerialLayer = function (apiKey, year) {
        var url = "https://wxs.ign.fr/{key}/geoportail/wmts?&" +
                  "REQUEST=GetTile&" + 
                  "SERVICE=WMTS&" +
                  "VERSION=1.0.0&" +
                  "STYLE=normal&" +
                  "TILEMATRIXSET=PM&" +
                  "FORMAT=image/jpeg&" + 
                  "LAYER=ORTHOIMAGERY.ORTHOPHOTOS&" +
                  "TILEMATRIX={z}&" +
                  "TILEROW={y}&" +
                  "TILECOL={x}";
        var attribution = am.translator.translate("backgroundLayer") + ' &copy; <a href="http://www.ign.fr">IGN</a>';
        if (year) {
            attribution += ' ' + year;
        }
        var options = {
            minNativeZoom: 1,
            maxNativeZoom: 19,
            maxZoom: 19,
            attribution: attribution,
            key: apiKey,
            className: 'am-base-layer',
            crossOrigin: true
        };
        var baseLayer = L.tileLayer(url, options);
        baseLayer.icon = '/img/pictures/map-ign-aerial.png';
        baseLayer.class = 'map-ign-aerial';
        baseLayer.id = 'map-ign-aerial';
        return baseLayer;
    };

    /**
     * Function returning an instance of L.TileLayer corresponding to OpenStreetMaps
     *
     * @return {L.TileLayer} - OpenStreetMaps maps
     */
    module.openStreetMapsLayer = function () {
        var options = {
            attribution: am.translator.translate("backgroundLayer") + ' &copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
            maxNativeZoom: 18,
            maxZoom: 20,
            className: 'am-base-layer',
            crossOrigin: true
        };
        var baseLayer = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', options);
        baseLayer.icon = '/img/pictures/map-osm.png';
        baseLayer.class = 'map-osm';
        baseLayer.id = 'map-osm';
        return baseLayer;
    };


    module.getIrradClasses = function(config) {
        // Compute the irradiation classes
        var irradiationClasses = config.irradiation.classes;
        var middleRangeColorRatio = config.irradiation.hasOwnProperty('middleRangeColorRatio') ? config.irradiation.middleRangeColorRatio : 0.5;
        irradiationClasses.sort(function(irradClass1, irradClass2) { // sort in ascending order
            return irradClass1.upperLimit - irradClass2.upperLimit;
        });
        for (var iIrradClass = 0, nIrradClasses = irradiationClasses.length; iIrradClass < nIrradClasses; ++iIrradClass) {
            var irradClass = irradiationClasses[iIrradClass];
            if (irradClass.lowerLimit === undefined) {
                irradClass.lowerLimit = (iIrradClass === 0) ? 0 : irradiationClasses[iIrradClass - 1].upperLimit;
            }
            if (irradClass.upperLimit === undefined) {
                irradClass.upperLimit = irradiationClasses[iIrradClass + 1].lowerLimit;
            }
            if (irradClass.lowerLimitColor === undefined) {
                irradClass.lowerLimitColor = (iIrradClass === 0) ? irradClass.upperLimitColor : irradiationClasses[iIrradClass - 1].upperLimitColor;
            }
            if (irradClass.upperLimitColor === undefined) {
                irradClass.upperLimitColor = (iIrradClass === nIrradClasses - 1) ? irradClass.lowerLimitColor : irradiationClasses[iIrradClass + 1].lowerLimitColor;
            }
            if (!irradClass.hasOwnProperty('middleRangeColor')) {
                var lowerLimitColor = (irradClass.lowerLimitColor.indexOf('rgb') !== -1) ?
                    irradClass.lowerLimitColor.replace(/(rgb\()|\)|\s/g, '').split(',') :
                    irradClass.lowerLimitColor;
                var upperLimitColor = (irradClass.upperLimitColor.indexOf('rgb') !== -1) ?
                    irradClass.upperLimitColor.replace(/(rgb\()|\)|\s/g, '').split(',') :
                    irradClass.upperLimitColor;
                irradClass.middleRangeColor = "rgb(" + am.utils.colorScale([lowerLimitColor, upperLimitColor]).getColor(middleRangeColorRatio).join(",") + ")";
            }
        }

        return irradiationClasses;
    };


    module.colorSolarPotentialDivs = function($parentElement, orientation, irradClasses) {
        orientation = orientation || "to left";
        for (var iIrradClass = 0, nIrradClasses = irradClasses.length; iIrradClass < nIrradClasses; ++iIrradClass) {
            var irradiationClass = irradClasses[iIrradClass];
            $parentElement.find('.am-surface-block[data-name="' + irradiationClass.name + '"]').css({
                'background-image': 'linear-gradient(' + orientation + ', ' + irradiationClass.lowerLimitColor + ', ' + irradiationClass.upperLimitColor + ')',
                color: irradiationClass.textColor || "black"
            });
        }
    };

    module.updateSolarPotentialDivs = function($parentElement, updateHeight, simulationResults) {
        if (simulationResults == undefined) {
            simulationResults = am.solarInstallationModel.getResults();
        }

        simulationResults.then(function(results) {
            var surfaces = results.surfacePerIrradiationClass.slice(); // shallow copy
            var totalRoofArea = surfaces.reduce(function(a, b) { return a + b; });
            var roundedSurfaces = surfaces.map(function(val) { return Math.round(val); });
            var roundedTotalRoofArea = roundedSurfaces.reduce(function(a, b) { return a + b; });
            if (Math.round(totalRoofArea) !== roundedTotalRoofArea) {
                var diff = Math.round(totalRoofArea) - roundedTotalRoofArea;
                roundedTotalRoofArea = Math.round(totalRoofArea);
                for (var iClass = 0; iClass < roundedSurfaces.length; ++iClass) {
                    if (Math.abs(diff) > 0 && roundedSurfaces[iClass] > 0) {
                        roundedSurfaces[iClass] += Math.sign(diff);
                        diff -= Math.sign(diff);
                    }
                }
            }
            $parentElement.find('.am-total-roof-surface .am-variable').html(am.translator.formatNumber(roundedTotalRoofArea));
            $parentElement.find('.am-potential-class-row').each(function(index, element) {
                var $element = $(element);
                $element.removeClass('am-disabled');
                var surface = Math.round(roundedSurfaces[roundedSurfaces.length - index - 1]);
                var percentage = Math.round(roundedSurfaces[roundedSurfaces.length - index - 1] / roundedTotalRoofArea * 100.);
                var irradClass = results.irradiationClasses[roundedSurfaces.length - index - 1];
                var lowerLimit = irradClass.lowerLimit;
                var upperLimit = irradClass.upperLimit;
                if (irradClass.units == '%') {
                    lowerLimit *= results.maxOptimalPotential / 100.;
                    upperLimit *= results.maxOptimalPotential / 100.;
                }

                var $infoButton = $element.find('.am-info-btn');
                if ($infoButton.length > 0) {
                    $infoButton.attr("data-total-surface", roundedTotalRoofArea + '&nbsp;m²');
                    $infoButton.attr("data-class-surface", surface + '&nbsp;m²');
                    $infoButton.attr("data-class-potential", percentage + '%');
                    $infoButton.attr("data-potential-lower-range", am.translator.formatNumber(lowerLimit, -1));
                    $infoButton.attr("data-potential-upper-range", am.translator.formatNumber(upperLimit, -1));
                }

                var $percentageBar = $element.find('.am-potential-class-bar .progress-bar');
                $percentageBar.attr('aria-valuenow', percentage + '');
                $percentageBar.width(percentage + '%');
                $element.find('.am-potential-class-surface .am-variable').html(am.translator.formatNumber(surface));
                if (surface < 1e-10) {
                    $element.addClass('am-disabled');
                }
            });

            if (updateHeight) {
                $parentElement.find('.am-surface-block-wrapper').outerHeight(Math.round(100 / roundedSurfaces.length) + '%');
            }
        });
    };

    /**
     * Creates and displays a message (div) next to the HTML element passed as input argument
     * @param {DomElement} domElement - Element next to which the message should be displayed
     * @param {String} htmlTemplate - Name of the HTML template which must be inserted inside the div 
     * @param {Object} templateOptions - Object to be passed to the template (the object will be known 
     *      as variable 'it' inside the template)
     * @param {String} location - Location of the message relative to the DOM element ('top', 'bottom', 
     *      'right', 'left')
     * @param {Object} [options] - List of options. The following properties can be specified:
     *      - customClass: Additional CSS class to be affected to the div containing the message
     *      - duration: Time (in seconds) during which the message should stay on screen.
     *          Defaults to a permanent message (the message stays on the screen and is not deleted)
     *      - xOffset: Offset (in pixels) of the message along the x-axis with respect to its default
     *          position
     *      - yOffset: Offset (in pixels) of the message along the y-axis with respect to its default
     *          position
     *      - width: Width (in pixels) of the message. The value 'inherit' can be specified to get the
     *          same width as the HTML element it is attached to.
     *      - height: Height (in pixels) of the message. The value 'inherit' can be specified to get the
     *          same height as the HTML element it is attached to.
     * @return {DomElement} - DOM element corresponding to the message. The value is returned only in
     *      case the message is permanent (see option 'duration')
     */
    module.displayMessageNextToElement = function(domElement, htmlTemplate, templateOptions, location, options) {
        var $domElement = $(domElement);
        var $parentElement = $domElement.parent();
        
        // Create the DOM element which will contain the message
        var $messageDiv = $('<div>');
        if (options.customClass) {
            $messageDiv.addClass(options.customClass);
        }
        am.templateManager.fillElementWithTemplate($messageDiv, htmlTemplate, templateOptions);

        // Position the DOM element displaying the message
        $messageDiv.css({
            'position': 'absolute',
            'display':  'none',
            'z-index':  9999
        });
        var domElementPos = $domElement.position();
        var domElementWidth = $domElement.outerWidth();
        var domElementHeight = $domElement.outerHeight();
        var xOffset = options.xOffset || 0;
        var yOffset = options.yOffset || 0;
        if (location == 'top') {
            $messageDiv.css({
                bottom: domElementPos.top + yOffset + 'px',
                left: domElementPos.left + xOffset + 'px',
            });
        } else if (location == 'bottom') {
            $messageDiv.css({
                top: domElementPos.top + domElementHeight + yOffset + 'px',
                left: domElementPos.left + xOffset + 'px',
            });
        } else if (location == 'left') {
            $messageDiv.css({
                top: domElementPos.top + yOffset + 'px',
                right: domElementPos.left + xOffset + 'px',
            });
        } else { // right
            $messageDiv.css({
                top: domElementPos.top + yOffset + 'px',
                left: domElementPos.left + domElementWidth + xOffset + 'px',
            });
        }

        // Set the width and height of the message
        if (options.width) {
            if (options.width == "inherit") {
                $messageDiv.width(domElementWidth);
            } else {
                $messageDiv.width(options.width);
            }
        }
        if (options.height) {
            if (options.height == "inherit") {
                $messageDiv.height(domElementHeight);
            } else {
                $messageDiv.height(options.height);
            }
        }

        // Display the message
        $messageDiv.appendTo($parentElement);
        $messageDiv.fadeIn(200);

        // Automatically hide and delete error message after some time (if required)
        if (options.duration) {
            setTimeout(function() {
                $messageDiv.fadeOut(200);
                setTimeout(function() {
                    $messageDiv.remove();
                }, 400);
            }, options.duration);
        } else {
            return $messageDiv;
        }
    };

    /**
     * Find if the user use Internet Explorer (Trident) or not
     * @param {String} strsearch - Name of the browser
     * @return {boolean} - true if IE (==Trident) or false
     * utile pour le point #3438 -> téléchargement d'un fichier
     */
    module.searchNavigator = function(strsearch) {
        var userAgent = navigator.userAgent;
        // Firefox : Mozilla/5.0 (Windows NT 6.3; WOW64; rv:38.0) Gecko/20100101 Firefox/38.0
        // Chrome :  ----------------------------------) AppleWebKit/, ... Chrome ... Safari

        var pos = userAgent.search(strsearch); //on pourrait aussi détecter : Chrome, Firefox -> Trident ( = nouveau IE !!!!)

        if (pos > 0)
            return true;
        else
            return false;
    };

    /**
     * Linearly interpolates between the x and y values passed as input arguments, and returns the value at the
     * specified point.
     *
     * @param {Number} x - Point at which the linear interpolation should be performed
     * @param {Number[]} xList - List of x values between which the interpolation should be performed
     * @param {Number[]} yList - List of y values between which the interpolation should be performed
     * @param {Boolean} extrapolate - Should the values be extrapolated in case x is outside of the range formed by the
     *      xList? If false, the min (resp. max) value of xList is returned. Defaults to False.
     */
    module.interpolateLinearly = function(x, xList, yList, extrapolate) {
        // Sort the input points
        var nPoints = xList.length;
        var pointList = [];
        for (var iPoint = 0; iPoint < nPoints; ++iPoint) {
            pointList.push({x: xList[iPoint], y: yList[iPoint]});
        }
        pointList.sort(function(a, b) { return a.x - b.x; }); // sort in ascending order
        for (var iPoint = 1; iPoint < nPoints; ++iPoint) {
            if (Math.abs(pointList[iPoint].x - pointList[iPoint - 1].x) < 1e-10) {
                throw new Error("The x values defining the piecewise linear function must be unique");
            }
        }

        // Treat the special case where only one input point is given
        if (nPoints === 1) {
            return pointList[0].y;
        }
        // Treat the case where x < min(xList)
        else if (x <= pointList[0].x) {
            return (extrapolate) ?
                (pointList[1].y - pointList[0].y) / (pointList[1].x - pointList[0].x) * (x - pointList[0].x) + pointList[0].y :
                pointList[0].y;
        }
        // Treat the case where x > max(xList)
        else if (x >= pointList[nPoints - 1].x) {
            return (extrapolate) ?
                (pointList[nPoints - 1].y - pointList[nPoints - 2].y) / (pointList[nPoints - 1].x - pointList[nPoints - 2].x) * (x - pointList[nPoints - 2].x) + pointList[nPoints - 2].y :
                pointList[nPoints - 1].y;
        }
        // Treat the case where x is in the range defined by xList
        else {
            for (var iPoint = 1; iPoint < nPoints; ++iPoint) {
                if (x <= pointList[iPoint].x) {
                    return (pointList[iPoint].y - pointList[iPoint - 1].y) / (pointList[iPoint].x - pointList[iPoint - 1].x) * (x - pointList[iPoint].x) + pointList[iPoint].y;
                }
            }
        }
    };

    module.closestValue = function(num, arr) {
        if (arr && arr.length) {
            var curr = parseInt(arr[0]);
            for (var index = 0; index < arr.length; index++) {
                var val = parseInt(arr[index]);
                if (Math.abs(num - val) < Math.abs(num - curr)) {
                    curr = val;
                }
            }
            return curr;
        }
        return undefined;
    };

    /**
     * Parses the CSV file containing the electricity consumption curve of the user
     * @param fileContents
     * @param timeShiftIsPresent
     * @returns {any[]}
     */
    module.parseElectricityConsumptionFile = function(fileContents, timeShiftIsPresent) {
        var iFirstMonthDay = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];

        // Initialize the output array
        var nHoursInOneYear = 24 * 365;
        var hourlyValues = new Array(nHoursInOneYear);
        var nHourlyValues = new Array(nHoursInOneYear);
        for (var iHour = 0; iHour < hourlyValues.length; ++iHour) {
            hourlyValues[iHour] = 0;
            nHourlyValues[iHour] = 0;
        }

        // Split file contents into separate lines
        fileContents = fileContents.trim().split('\n');
        if (fileContents.length === 1) {// handle the case of CSV files created under MacOS
            fileContents = fileContents.trim().match(/[^\r\n]+/g);
        }

        // Parse file header and get the indices of the columns containing the date, hour and value. Get also the units.
        var header = fileContents[0].trim();
        var separator = header.indexOf(';') !== -1 ? ';' :
            header.indexOf('\t') !== -1 ? '\t' :
                ',';
        var fileInfo = parseElectricityConsumptionFileHeader(fileContents, 0, separator);
        var iDateCol = fileInfo.dateColumnIndex,
            iHourCol = fileInfo.hourColumnIndex,
            iValueCol = fileInfo.valueColumnIndex;
        if (iDateCol === undefined || iHourCol === undefined || iValueCol === undefined) {
            throw new Error("Error while parsing file " + fileName + ": unrecognized format");
        }

        // Parse file body
        for (var iLine = fileInfo.dataStartLineIndex; iLine < fileContents.length; ++iLine) {
            // Parse current line
            var lineContents = fileContents[iLine].trim().split(separator);
            if (lineContents.length <= Math.max(iDateCol, iHourCol, iValueCol)) {
                continue;
            }

            // Get date
            var day, month, year;
            var dateString = lineContents[iDateCol];
            if (dateString.search(/^\d{4}.\d{2}.\d{2}/) !== -1) {
                year = parseInt(dateString.substring(0, 4));
                month = parseInt(dateString.substring(5, 7)) - 1;
                day = parseInt(dateString.substring(8, 10));
            } else {
                day = parseInt(dateString.substring(0, 2));
                month = parseInt(dateString.substring(3, 5)) - 1;
                year = parseInt(dateString.substring(6, 10));
            }

            // Get time
            var hourString = lineContents[iHourCol];
            var iStartHour = hourString.search(/\d{2}:\d{2}/);
            var hour = parseInt(hourString.substring(iStartHour, iStartHour + 2));
            var min = parseInt(hourString.substring(iStartHour + 3, iStartHour + 5));

            // Compute the current hour index with respect to the first day of the year
            var iValue;
            if (timeShiftIsPresent) { // consider all dates as if they were expressed in local French time
                var date = new Date(year, month, day, hour, min);
                var firstDayOfYear = new Date(year, 0);
                iValue = Math.floor((date.getTime() - firstDayOfYear.getTime()) / (3600 * 1000)); // number of hours since year start
                if (year % 4 === 0 && iValue >= iFirstMonthDay[2] * 24) { // correct value for leap years
                    iValue -= 24;
                }
            } else {
                iValue = (iFirstMonthDay[month] + day - 1) * 24 + hour;
            }
            if (iValue >= nHoursInOneYear) {
                iValue = iValue % nHoursInOneYear;
            } else if (iValue < 0) {
                iValue = iValue + Math.ceil(Math.abs(iValue) / nHoursInOneYear) * nHoursInOneYear;
            }

            // Save value in the output variable
            var value = parseFloat(lineContents[iValueCol].replace(',', '.'));
            if (!isNaN(value)) {
                hourlyValues[iValue] += value;
                ++nHourlyValues[iValue];
            }
        }

        // Check that (almost) all values have been provided
        var nEmptyValues = nHourlyValues.reduce(function(sum, val) {
            return val > 0 ? sum : sum + 1;
        }, 0);
        if (nEmptyValues > 0.05 * nHoursInOneYear) {
            throw new Error("Error while parsing file " + fileName + ": data do not cover a complete year");
        }

        // Return the output variable
        return hourlyValues.map(function(val, iVal) {
            return nHourlyValues[iVal] > 0 ? val / nHourlyValues[iVal] * fileInfo.unitConversionFactor : undefined;
        });
    };

    /**
     * This function sends the information passed as input argument to the backend so as to store them in a CSV file
     * and/or send an email to the website owner.
     * @param {Object} contactInfo - List of parameters to send to the backend
     * @returns Promise which either resolves with a success message if the backend returns no error code, or rejects
     *      with an error message in case of an error
     */
    module.processContactInformation = function(contactInfo) {
        // Construct the body of the email
        var userType = (contactInfo.userType !== undefined) ? '-' + contactInfo.userType : '';
        var emailBody = am.translator.translate('contactRequestEmailBody' + userType);
        emailBody.replace('[[LINK]]', window.location.href);
        var placeHolders = emailBody.match(/\[{2}[\w\-]+\]{2}/g);
        if (placeHolders) {
            placeHolders.forEach(function(placeHolder) {
                // Convert placeholder name to camel case
                var key = placeHolder.replace(/\[|\]/g, '').split('-').map(function(part, iPart) {
                    return (iPart > 0 ? part[0].toUpperCase() : part[0].toLowerCase()) + part.substring(1).toLowerCase();
                }).join('');

                // If a corresponding entry could be found in the contactInfo object, replace the place holder with its
                // corresponding value
                if (contactInfo.hasOwnProperty(key)) {
                    emailBody = emailBody.replace(placeHolder, contactInfo[key]);
                }
            });
        }

        // Complete the contactInfo object
        contactInfo.mailSubject = am.translator.translate('contactRequestEmailSubject');
        contactInfo.mailBody = emailBody;

        // Send information to the backend
        return new Promise(function(resolve, reject) {
            $.ajax({
                //dataType: 'json',
                data: contactInfo,
                type: "POST",
                url: "/backend/processRequest.php",
                success: function(msg) {
                    if (msg === "email_send_successfully") {
                        resolve(msg);
                    } else {
                        reject(msg);
                    }
                },
                error: function(useless, msg) {
                    reject(msg);
                }
            });
        });
    };

    /**
     * Function to be called when a contact form is submitted (event 'submitted' emitted by the form element)
     * @param {Object} event - Event emitted when the form is submitted
     */
    module.contactFormValidationCallback = function(event) {
        event.preventDefault();
        var $submitButton = $(this).find('button[type="submit"]');

        // Get the form values as a plain JS object
        var $form = $(this);
        var formValues = {
            comments: $form.attr('data-contact-reason'),
            userType: $form.attr('data-contact-user-type'),
            projectLink: window.location.href
        };
        $(this).serializeArray().forEach(function(element) {
            formValues[element.name] = element.value;
        });
        $(this).find('input[type=checkbox]').each(function(iCb, cb) {
            if (cb.name !== "okToSendCoordinates") {
                formValues[cb.name] = am.translator.translate(formValues.hasOwnProperty(cb.name) ? 'yes' : 'no');
            }
        });
        if ($form.attr('data-mail-recipient')) {
            formValues.mailRecipients = $form.attr('data-mail-recipient').trim().split(/\s+/g);
        }

        if (formValues.okToSendCoordinates === "on") {
            // Button the button in "wait state"
            $submitButton.prop('disabled', true);
            var buttonContents = $submitButton.html(); // store to restore later
            $submitButton.html('<div class="btn-picto"><i class="am-icon am-icon-btn am-wait-icon"></i></div>' +
                '<div class="btn-text text-center">' + am.translator.translate('requestWaiting') + '</div>');

            // Send request
            am.utils.processContactInformation(formValues).then(function(msg) {
                $submitButton.html(am.translator.translate(msg));
                $submitButton.prop('disabled', true);
            }).catch(function (msg) {
                am.utils.displayMessageNextToElement($submitButton, 'error-message', {
                    message: am.translator.translate('serverError')
                }, 'bottom', {
                    customClass: 'am-dropdown-error-message',
                    duration: 3000,
                    width: 'inherit'
                });

                // Restore button contents
                $submitButton.prop('disabled', false);
                $submitButton.html(buttonContents);
            });
        } else {
            am.utils.displayMessageNextToElement($submitButton, 'error-message', {
                message: am.translator.translate('youMustAgreeToContinue')
            }, 'bottom', {
                customClass: 'am-dropdown-error-message',
                duration: 3000,
                width: 'inherit'
            });
        }
    };

    module.updateSolarPotentialDivsDatabase = function($parentElement, results) {
        $parentElement.find('.am-total-roof-surface .am-variable').html(am.translator.formatNumber(results["total-surface"]));
    
        var roundedSurfacesKeys = Object.keys(results.irradiationSurface), roundedSurfaces = [];
        roundedSurfacesKeys.forEach(function(sKey){
          roundedSurfaces.push(results.irradiationSurface[sKey])
        });
    
        $parentElement.find('.am-potential-class-row').each(function(index, element) {
            var $element = $(element);
            $element.removeClass('am-disabled');
            var surface = Math.round(roundedSurfaces[roundedSurfaces.length - index - 1].value);
            var percentage = Math.round(roundedSurfaces[roundedSurfaces.length - index - 1].percentage);
            var irradClass = results.irradiationClasses[roundedSurfaces.length - index - 1];
            var lowerLimit = irradClass.lowerLimit;
            var upperLimit = irradClass.upperLimit;
            if (irradClass.units == '%') {
              lowerLimit *= results.maxIrradiationValue / 100.;
              upperLimit *= results.maxIrradiationValue / 100.;
            }
    
            var $infoButton = $element.find('.am-info-btn');
            if ($infoButton.length > 0) {
              $infoButton.attr("data-total-surface", surface + '&nbsp;m²');
              $infoButton.attr("data-class-surface", surface + '&nbsp;m²');
              $infoButton.attr("data-class-potential", percentage + '%');
              $infoButton.attr("data-potential-lower-range", am.translator.formatNumber(lowerLimit, -1));
              $infoButton.attr("data-potential-upper-range", am.translator.formatNumber(upperLimit, -1));
            }
    
            var $percentageBar = $element.find('.am-potential-class-bar .progress-bar');
            $percentageBar.attr('aria-valuenow', percentage + '');
            $percentageBar.width(percentage + '%');
            $element.find('.am-potential-class-surface .am-variable').html(am.translator.formatNumber(surface));
            if (surface < 1e-10) {
              $element.addClass('am-disabled');
            }
        });
      };

    /**
     * This function returns a jpg base64-encoded screenshot image of the Leaflet map passed as input argument
     * WARNING: all Leaflet tile layers must be loaded with the option 'crossOrigin' set to true, otherwise the tiles
     *      won't be printed in the screenshot (see https://leafletjs.com/reference-1.3.4.html#tilelayer-crossorigin).
     *      This is also true for all images in general: the tag <img> must have the attribute 'crossorigin' present,
     *      otherwise they cannot be captured in a canvas (see
     *      https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image).
     * LIMITATIONS: the function returns what is actually seen on the screen: missing tiles will also be missing in the
     *      screenshot. This limitation could be circumvented by sending AJAX requests to load the missing tiles.
     * @param {HTMLElement} mapDomElement - DOM element containing the Leaflet map
     * @param {Number} xOffset - x-coordinate of the upper-left corner of the screenshot with respect to the upper-left
     *      corner of the padding box (which excludes the margins and the borders) of the map DOM element. The offset
     *      must be provided in pixels.
     * @param {Number} yOffset - y-coordinate of the upper-left corner of the screenshot with respect to the upper-left
     *      corner of the padding box (which excludes the margins and the borders) of the map DOM element. The offset
     *      must be provided in pixels.
     * @param {Number} width - Width of the screenshot, in pixels
     * @param {Number} height - Height of the screenshot, in pixels
     * @param {String[]} panesToCapture - List of Leaflet panes to include in the screenshot. By default, all panes are
     *      included. The following panes can be specified: 'tile', 'shadow', 'overlay', 'marker', 'tooltip' and 'popup'.
     */
    module.takeLeafletScreenshot = function(mapDomElement, xOffset, yOffset, width, height, panesToCapture) {
        var $map = $(mapDomElement);

        // Process the input arguments to define the default values
        if (xOffset === undefined) xOffset = 0;
        if (yOffset === undefined) yOffset = 0;
        if (width === undefined) width = $map.innerWidth();
        if (height === undefined) height = $map.innerHeight();

        // Create the canvas which will store the screenshot
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var canvasContext = canvas.getContext('2d');

        // Get the absolute coordinates of the screenshot
        var mapAbsolutePosition = $map.offset(); // the returned position corresponds to the upper-left corner of the border box (ignoring the margins but including the borders)
        var mapLeftBorderWidth = parseInt($map.css('borderLeftWidth'));
        var mapTopBorderWidth = parseInt($map.css('borderTopWidth'));
        var xMinScreenshot = mapAbsolutePosition.left + (isNaN(mapLeftBorderWidth) ? 0 : mapLeftBorderWidth) + xOffset,
            yMinScreenshot = mapAbsolutePosition.top + (isNaN(mapTopBorderWidth) ? 0 : mapTopBorderWidth) + yOffset,
            xMaxScreenshot = xMinScreenshot + width,
            yMaxScreenshot = yMinScreenshot + height;

        // List the panes to capture
        var $panes = $map.find('.leaflet-map-pane .leaflet-pane');
        if (panesToCapture !== undefined && panesToCapture.length > 0) {
            $panes.filter('.leaflet-' + panesToCapture.join('-pane,.leaflet-') + '-pane');
        }

        // Recursively capture each <img> and <canvas> element
        function captureImages(parentElements) {
            parentElements.sort(function(a, b) { return $(a).zIndex() - $(b).zIndex(); }); // sort the elements according to their z-index
            parentElements.forEach(function(parentElement) {
                var $parentElement = $(parentElement);
                var nodeType = parentElement.nodeName.toLowerCase();

                if (nodeType === 'img' || nodeType === 'canvas') {
                    // Skip current element if it is an image and the CORS attribute has not been set (otherwise the
                    // canvas would be tainted and not usable any more)
                    if (nodeType === "img" && (parentElement.crossOrigin == undefined || parentElement.crossOrigin.toLowerCase() === "no-cors")) {
                        return;
                    }

                    // Get the absolute position of the image
                    var imgAbsolutePosition = $parentElement.offset();
                    var xMinImg = imgAbsolutePosition.left,
                        yMinImg = imgAbsolutePosition.top,
                        xMaxImg = xMinImg + $parentElement.outerWidth(),
                        yMaxImg = yMinImg + $parentElement.outerHeight();

                    // If the image intersects the screenshot area, print its contents into the canvas
                    if (xMaxImg > xMinScreenshot && xMinImg < xMaxScreenshot && yMaxImg > yMinScreenshot && yMinImg < yMaxScreenshot) {
                        try {
                            canvasContext.drawImage(parentElement, xMinImg - xMinScreenshot, yMinImg - yMinScreenshot);
                        } catch (e) {
                            // nothing to do
                        }
                    }
                } else if (parentElement.childNodes.length > 0) {
                    captureImages(Array.from(parentElement.childNodes));
                }
            });
        }
        captureImages($panes.get());

        // Returns the contents of the canvas as a base64-encoded jpg image
        return canvas.toDataURL("image/jpeg");
    };

    /**
     * Private function parsing the header of the CSV file containing the electricity consumption curve of the user
     * @param fileContents
     * @param iHeaderLine
     * @param separator
     * @returns {{dateColumnIndex: *, hourColumnIndex: *, valueColumnIndex: *, dataStartLineIndex: *, unitConversionFactor: number}}
     */
    function parseElectricityConsumptionFileHeader (fileContents, iHeaderLine, separator) {
        var iDateCol, iHourCol, iValueCol;
        var iDataStartLine = iHeaderLine + 1;
        var conversionFactor = 1.0;

        // Extract the conversion factor from the units
        var getConversionFactor = function(units) {
            switch (units) {
                case 'w':
                    return 1e-3;
                case 'kw':
                    return 1;
                default:
                    console.warn("Unknown power units '" + units + "'");
                    return 1;
            }
        };
        
        // Identify the indices of the columns containing the date, time and values
        var header = fileContents[iHeaderLine].trim().split(separator);
        var isHeaderPresent = true;
        header.forEach(function(columnName, iCol) {
            columnName = columnName.trim().toLowerCase();
            if (iDateCol === undefined && iHourCol === undefined &&
                columnName.search(/^((\d{2}.\d{2}.\d{4})|(\d{4}.\d{2}.\d{2})).\d{2}:\d{2}/) !== -1) {
                iDateCol = iCol;
                iHourCol = iCol;
                isHeaderPresent = false;
            } else if (iDateCol === undefined && iHourCol === undefined && columnName.search(/^horodate($|\s)/) !== -1) {
                iDateCol = iCol;
                iHourCol = iCol;
            } else if (iDateCol === undefined && columnName.search(/^(\d{2}.\d{2}.\d{4})|(\d{4}.\d{2}.\d{2})$/) !== -1) {
                iDateCol = iCol;
                isHeaderPresent = false;
            } else if (iDateCol === undefined && columnName.search(/^date($|\s)/) !== -1) {
                iDateCol = iCol;
            } else if (iHourCol === undefined && columnName.search(/^\d{2}:\d{2}/) !== -1) {
                iHourCol = iCol;
                isHeaderPresent = false;
            } else if (iHourCol === undefined && columnName.search(/^(hour|heure)($|\s)/) !== -1) {
                iHourCol = iCol;
            } else if (iValueCol === undefined && columnName.search(/^(value|valeur)($|\s)/) !== -1) {
                iValueCol = iCol;
                if (columnName.search(/^valeur\s+\(en\s+\w+\)/) !== -1) {
                    conversionFactor = getConversionFactor(columnName.match(/^valeur\s+\(en\s+(\w+)\)/)[1]);
                }
            } else if ((iValueCol === undefined && columnName === 'p1') || columnName === 'pt') { // Format PEL103
                iValueCol = iCol;
                conversionFactor = 1e-3;
                iDataStartLine = iHeaderLine + 2;
            } else if (columnName.search(/^unit.{0,2}($|\s)/) !== -1 && fileContents.length > iDataStartLine) {
                var values = fileContents[iDataStartLine].trim().split(separator);
                if (values.length > iCol) {
                    conversionFactor = getConversionFactor(values[iCol].trim().toLowerCase());
                }
            }
        });
        if (!isHeaderPresent) {
            iValueCol = iHourCol + 1;
            iDataStartLine = 0;
        }

        // Make a second try if all indices could not be found
        if ((iDateCol === undefined || iHourCol === undefined || iValueCol === undefined) && fileContents.length > iHeaderLine + 2) {
            var headerInfo = parseElectricityConsumptionFileHeader(fileContents, iHeaderLine + 2, separator);
            iDateCol = headerInfo.dateColumnIndex;
            iHourCol = headerInfo.hourColumnIndex;
            iValueCol = headerInfo.valueColumnIndex;
            iDataStartLine = headerInfo.dataStartLineIndex;
        }

        // Return the extracted information
        return {
            dateColumnIndex: iDateCol,
            hourColumnIndex: iHourCol,
            valueColumnIndex: iValueCol,
            dataStartLineIndex: iDataStartLine,
            unitConversionFactor: conversionFactor
        };
    }

    return module;

})(am.utils || {});


Set.prototype.join = function(otherSet) {
    var self = this;
    otherSet.forEach(function(value) {
        self.add(value);
    });
    return this;
};

Set.prototype.remove = function(otherSet) {
    var self = this;
    otherSet.forEach(function(value) {
        self.delete(value);
    });
    return this;
};

Set.prototype.getUnionWith = function(otherSet) {
    var output = new Set();
    output.fromArray(this); // copy current set
    otherSet.forEach(function(value) {
        output.add(value);
    });
    return output;
};

Set.prototype.getIntersectionWith = function(otherSet) {
    var output = new Set();
    this.forEach(function(value) {
        if (otherSet.has(value)) {
            output.add(value);
        }
    });
    return output;
};

Set.prototype.getDifferenceWith = function(otherSet) {
    var output = new Set();
    this.forEach(function(value) {
        if (!otherSet.has(value)) {
            output.add(value);
        }
    });
    return output;
};

Set.prototype.fromArray = function(array) {
    this.clear();
    var self = this;
    array.forEach(function(value) {
        self.add(value);
    });
    return this;
};

Set.prototype.toArray = function() {
    var output = [];
    this.forEach(function(value) {
        output.push(value);
    });
    return output;
};